import { FilesetResolver, FaceLandmarker, ImageSegmenter } from '@mediapipe/tasks-vision'

export async function ensureVisionResources(existing = {}, defaults, options = {}) {
  const result = {
    vision: existing.vision || null,
    faceLandmarker: existing.faceLandmarker || null,
    faceLandmarkerImage: existing.faceLandmarkerImage || null,
    segmenter: existing.segmenter || null,
    segmenterImage: existing.segmenterImage || null,
    hairSegmenterImage: existing.hairSegmenterImage || null
  }

  const mode = options.mode || 'both' // 'image' | 'video' | 'both'
  const needImage = mode === 'image' || mode === 'both'
  const needVideo = mode === 'video' || mode === 'both'

  if (!result.vision) {
    result.vision = await FilesetResolver.forVisionTasks(defaults.wasmPath)
  }
  const visionFs = result.vision

  if (!defaults.disableFace) {
    if (needVideo && !result.faceLandmarker) {
      result.faceLandmarker = await FaceLandmarker.createFromOptions(visionFs, {
        baseOptions: { modelAssetPath: defaults.faceModelPath },
        runningMode: 'VIDEO',
        numFaces: 1,
        outputFaceBlendshapes: true,
        outputFacialTransformationMatrixes: false,
        // Lower confidence thresholds for better face detection (default 0.5)
        minFaceDetectionConfidence: 0.4,
        minFacePresenceConfidence: 0.4,
        minTrackingConfidence: 0.4
      })
    }
    if (needImage && !result.faceLandmarkerImage) {
      result.faceLandmarkerImage = await FaceLandmarker.createFromOptions(visionFs, {
        baseOptions: { modelAssetPath: defaults.faceModelPath },
        runningMode: 'IMAGE',
        numFaces: 1,
        outputFaceBlendshapes: true,
        outputFacialTransformationMatrixes: false,
        // Lower confidence thresholds for better face detection (default 0.5)
        minFaceDetectionConfidence: 0.4,
        minFacePresenceConfidence: 0.4,
        minTrackingConfidence: 0.4
      })
    }
  }

  if (!defaults.disableSegmentation) {
    if (needVideo && !result.segmenter) {
      result.segmenter = await ImageSegmenter.createFromOptions(visionFs, {
        baseOptions: { modelAssetPath: defaults.segmentModelPath },
        runningMode: 'VIDEO',
        outputCategoryMask: true,
        outputConfidenceMasks: true
      })
    }
    if (needImage && !result.segmenterImage) {
      try {
        result.segmenterImage = await ImageSegmenter.createFromOptions(visionFs, {
          baseOptions: { modelAssetPath: defaults.segmentModelPath },
          runningMode: 'IMAGE',
          outputCategoryMask: true,
          outputConfidenceMasks: true
        })
      } catch (err) {
        result.segmenterImage = null
        console.warn('[AvatarEngine] Segmenter (IMAGE) init failed', err)
      }
    }
  }

  if (!defaults.disableAvatarHair && needImage && !result.hairSegmenterImage) {
    try {
      result.hairSegmenterImage = await ImageSegmenter.createFromOptions(visionFs, {
        baseOptions: { modelAssetPath: defaults.hairModelPath },
        runningMode: 'IMAGE',
        outputCategoryMask: true,
        outputConfidenceMasks: true
      })
    } catch (err) {
      result.hairSegmenterImage = null
      console.warn('[AvatarEngine] Hair segmenter init failed', err)
    }
  }

  return result
}

export async function initVision(defaults, options = {}) {
  return ensureVisionResources({}, defaults, options)
}

export default { initVision }
